export interface ButtonDefaultOptions {
  busyLabel?: string;
  busyFontIcon?: string;
  buttonStyle?: string;
  color?: string;
  cssClass?: string;
}
